// ----------------------------------------------------------------------------
// Application JavaScript
// ----------------------------------------------------------------------------
//
// All scripts are loaded to the project through this master script sheet,
// which bundles our code via Webpack.
//
// Includes are listed alphabetically for easiest identification.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './libs/jquery';         // Load jQuery globally
import './libs/feature-detect'; // Feature Detection (Modernizr)
import './libs/a11y';           // Accessibility
import './libs/spritesheet';    // Spritesheet
import './libs/lazysizes';      // Lazysizes
// import './libs/webfonts';       // Web Fonts (optional)


// -------------------------------------
// Load Base Styles
// -------------------------------------

// Theme Scripts
import '../../scripts/sections/header';
import '../../scripts/sections/accordion';
import '../../scripts/sections/announcement-bar';
import '../../scripts/sections/carousel';
import '../../scripts/sections/search';
import '../../scripts/sections/video-block';
import '../../scripts/sections/ajax-add-cart';
import '../../scripts/sections/ajax-cart-page';
import '../../scripts/sections/content-panel-video';

import '../../scripts/snippets/country-modal/country-modal';
import '../../scripts/snippets/recharge/recharge';
import '../../scripts/sections/tabs';
import '../../scripts/snippets/ga-tags';
import '../../scripts/snippets/modal';
import '../../scripts/snippets/free-shipping-progress';
import '../../scripts/snippets/mini-cart';
import '../../scripts/snippets/form';
import '../../scripts/snippets/header-menu';


// -------------------------------------
// Load Templates
// -------------------------------------

import '../../scripts/templates/cart';
import '../../scripts/templates/collection';
import '../../scripts/templates/gift_card';
import '../../scripts/templates/index';
import '../../scripts/templates/product';
import '../../scripts/templates/product.coming-soon';
import '../../scripts/templates/product.free-sample';
import '../../scripts/templates/customers/addresses';
import '../../scripts/templates/customers/login';

// Styles
import '../../styles/theme.scss';
import '../../styles/theme.scss.liquid';


// -------------------------------------
// Load Sections
// -------------------------------------

import {load} from '@shopify/theme-sections';

document.addEventListener('DOMContentLoaded', () => {
    load('*');
});


// -------------------------------------
// Inline Scripts
// -------------------------------------

const validate = require('jquery-validation');

// iamota: function pulled from cart.cjs.js, it was removed from theme.cart.js and can't be imported properly
function cookiesEnabled() {
  var cookieEnabled = navigator.cookieEnabled;

  if (!cookieEnabled) {
    document.cookie = 'testcookie';
    cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
  }
  return cookieEnabled;
}

if (cookiesEnabled()) {
  document.documentElement.className = document.documentElement.className.replace(
    'supports-no-cookies',
    'supports-cookies',
  );
}


// Add jQUery Validation to all forms
$('.form').not('.form--custom-validation').each(function() {
    $(this).validate();
});



// Adds custom increment functionality
// It would be nice if this didn't live here in theme.js
const $formInput = $('.form__input[type="number"]');

if ($formInput) {
    $('.form__increment').on('click', function() {

        var $button = $(this);
        var oldValue = $button.parent().find('input').val();

        $button.parent().find('input').focus();

        if ($button.hasClass('form__increment--up')) {
            var newVal = parseFloat(oldValue) + 1;
        } else {
            // Don't allow decrementing below zero
            if (oldValue > 1) {
                var newVal = parseFloat(oldValue) - 1;
            } else {
                newVal = 1;
            }
        }

        $button.parent().find('input').val(newVal).trigger('change');
        $('button[name=update_cart]').prop('disabled', false);

    });
}
